import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button
} from "@mui/material";
import http from "../../commonFunctions/httpClient";
import { useSnackbar } from "../Snackbar/SnackBarContext";

interface ConfirmationPopupProps {
  apiUrl: string;
  id: string | number;
  confirmMessage: string;
  onConfirm?: (data: any) => void;
  onCancel?: () => void;
  open: boolean;
  onClose: () => void;
  permanent?: boolean;
}

const ConfirmationPopup: React.FC<ConfirmationPopupProps> = ({
  apiUrl,
  id,
  confirmMessage,
  onConfirm,
  onCancel,
  open,
  onClose,
  permanent
}) => {
  const {showMessage} = useSnackbar();
  const handleConfirm = async () => {
    try {
      const response: any = await http.put(apiUrl + "/" + id, {});
      if (onConfirm) onConfirm(response);
    } catch (error:any) {
      console.error("Error deleting:", error);
      if (error.message === 'GlobalHandledError') return;
        showMessage(error.response?.data?.message || "An unexpected error occurred","error");
    } finally {
      onClose();
    }
  };

  const handleConfirmDelete = async () => {
    try {
      const response: any = await http.del(apiUrl + "/" + id, {});
      if (onConfirm) onConfirm(response);
    } catch (error:any) {
      console.error("Error deleting:", error);
      if (error.message === 'GlobalHandledError') return;
        showMessage(error.response?.data?.message || "An unexpected error occurred","error");
    } finally {
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirmation</DialogTitle>
      <DialogContent>
        <DialogContentText>{confirmMessage}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel || onClose} color="inherit" variant="contained">
          No
        </Button>
        <Button
          onClick={permanent ? handleConfirmDelete : handleConfirm}
          color="warning"
          variant="contained"
          sx={{
      backgroundColor: "#FF6B2C",
      textTransform: "none",
      "&:hover": { backgroundColor: "#e65c1d" }
    }}
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationPopup;
